import { api } from "../shared/utilities/api";
import apiConfigs from "../shared/utilities/apiConfigs";

const JSON_HEADERS = { "Content-Type": "application/json" };

export const validateToken = (hin, dob, token, orgId) =>
    api(apiConfigs.baseOption("POST", "intakeForm/validate", {
        headers: JSON_HEADERS,
        data: { hin, dob, token, orgId },
    }));

export const setTokenExpired = (token, orgId) =>
    api(apiConfigs.baseOption("POST", "intakeForm/setExpired", {
        headers: JSON_HEADERS,
        data: { token, orgId },
    }));

export const uploadPdf = (token, orgId, hin, formData) =>
    api(apiConfigs.baseOption("POST", "intakeForm/uploadPdf", {
        headers: JSON_HEADERS,
        data: { token, orgId, hin, formData },
    }));
